const convertMoney = (number) => {
	return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null
}

export default convertMoney
